import OutlinedTextField from '../../textboxes/OutlinedTextField';
import * as React from 'react';

interface Props {
  issuer: string;
  ssoURL: string;
  certificate: string;
  onChangeSAMLTextfields?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const SAMLInputs = (props: Props) => {
  return (
    <div className="authentication-admin-sso-menu-inputs">
      <OutlinedTextField
        testid={'issuer-uri'}
        id="issuer"
        label={'Issuer URI'}
        placeholder={
          'https://example.com/saml/metadata/abc123-1234-567d-4891-1f23ghi4567'
        }
        value={props.issuer}
        onChange={props.onChangeSAMLTextfields}
        helperText={
          'The Issuer URI for SAML, used by the provider as the Issuer Identifier.'
        }
      />

      <OutlinedTextField
        testid={'sso-url'}
        id="ssoURL"
        label={'SSO URL / Entry Point URI'}
        placeholder={
          'https://example.com/trust/saml2/http-post/sso/abc123-1234-567d-4891-1f23ghi4567'
        }
        value={props.ssoURL}
        onChange={props.onChangeSAMLTextfields}
        helperText={
          'The Entry Point URI for SAML, used by the identity provider.'
        }
      />

      <OutlinedTextField
        testid={'certificate'}
        id="certificate"
        multiline={true}
        rows={12}
        label={'Certificate'}
        placeholder={'Enter your Cert contents'}
        value={props.certificate}
        onChange={props.onChangeSAMLTextfields}
        helperText={
          'The certificate (X509 / RSA) contents used to securely sign requests to the Identity Provider.'
        }
        type={'text'}
      />
    </div>
  );
};

export default SAMLInputs;
